import React from "react";

const HeroSection = () => {
  return (
    <>
      <section className="inquery">
        <div className="bg-image-1">
          <div className="bg-overlay-1"></div>
          <div className="container content">
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                <h2>Contact Us</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
